<script setup lang="ts">
import '@patsnap-ui/icon/assets/solid/SmallDot.svg';
import '@patsnap-ui/icon/assets/solid/tick.svg';
import '@patsnap-ui/icon/assets/solid/CloseBig.svg';
import '@patsnap-ui/icon/assets/solid/LoadingCircle.svg';

const EXECUTING = 'executing';
const UNEXECUTED = 'unexecuted';
const SUCCESS = 'success';
const FAIL = 'fail';

type ProcessStatus = typeof EXECUTING | typeof UNEXECUTED | typeof SUCCESS | typeof FAIL;

withDefaults(defineProps<{
    status?: ProcessStatus,
    label: string;
}>(), {
    status: 'unexecuted',
});

const iconMap = {
    [EXECUTING]: '#SolidLoadingCircle',
    [UNEXECUTED]: '#SolidSmallDot',
    [SUCCESS]: '#SolidTick',
    [FAIL]: '#SolidCloseBig',
};

</script>

<template>
    <div :class="['calculation-process-render group flex items-center', `process-${status}`]">
        <svg
            width="24"
            height="24"
            class="mr-1 shrink-0 fill-gray-450"
            :class="{
                '!fill-gray-55': UNEXECUTED === status || FAIL === status,
                '!fill-eureka-500': SUCCESS === status,
                'animate-[icon-spin_2s_linear_infinite]': EXECUTING === status,
            }"
        >
            <use :xlink:href="iconMap[status]" />
        </svg>
        <div
            class="relative overflow-hidden leading-6"
            :class="{
                'text-gray-90': UNEXECUTED === status,
                'text-gray-450': EXECUTING === status
            }"
        >
            <span>{{ label }}</span>
            <div v-if="EXECUTING === status" class="absolute top-0 h-full w-full animate-[text-scan_2s_linear_infinite] border-r-2 border-eureka-500">
                <span class="absolute left-0 top-0 h-full w-full [background:linear-gradient(270deg,rgba(7,100,233,0.15)_0%,rgba(7,100,233,0)_96.88%)]" />
                <span class="absolute left-full top-0 h-full w-full rotate-180 [background:linear-gradient(270deg,rgba(7,100,233,0.15)_0%,rgba(7,100,233,0)_96.88%)]" />
            </div>
        </div>
    </div>
</template>

<style>
@keyframes icon-spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(359deg);
    }
}
@keyframes text-scan {
    0% {
        right: 100%;
    }

    50% {
        right: 0
    }

    100% {
        right: 100%;
    }
}
</style>
